export enum EstimationChoice {
  Basic = "basic",
  Industry = "industry",
  Reading = "reading",
}
